import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { listSectionPeriodsSvc, getLstSubjectSvc, listEligibleTchSvc, getCommonClsListSvc } from './CommonClsSvc'
import EligibleTchPopup2 from "./EligibleTchPopup2";

function CommonClsSlider2(props) {
    const [subId, setSubId] = useState(0)
    const [lstSubject, setLstSubject] = useState([])
    const [lstSection, setLstSection] = useState([])
    const [lstSectionId, setLstSectionId] = useState([])
    const [lstSecPeriod, setLstSecPeriod] = useState([])
    const [daysOff, setDaysOff] = useState("0000000");
    const [periodsOff, setPeriodsOff] = useState("0000000000");
    const [loader, setLoader] = useState("none");
    const [tchId, setTchId] = useState(0)
    const [lstTch, setLstTch] = useState([])
    const [sectionId, setSectionId] = useState(0)
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const dayIndex = {
        mon: 0,
        tue: 1,
        wed: 2,
        thu: 3,
        fri: 4,
        sat: 5,
        sun: 6
    };
    useEffect(() => {
        // console.log(props)
        setSubId(props.subId)
        setDaysOff(props.daysOff)
        setPeriodsOff(props.periodsOff)
        if (props.subId !== 0) {
            listSectionPeriodsSvc(props.commonClsId, props.subId, cbSectionPeriodResponse)
        }
        getLstSubjectSvc(cbSubjectReponse)
    }, [props])

    function cbSubjectReponse(data) {
        // console.log(data.lstSubject)
        if (data.status === "Success") {
            setLstSubject(data.lstSubject)
        } else {
            if (data.message === "You are not logged in") {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else if (data.message === "Your Session is expired, login again") {
                toast.error(data.SvcMsg);
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        }
        setLoader('none')
    }
    function cbSectionPeriodResponse(data) {
        // console.log("cbSectionPeriodResponse() in CommonClsSlider, data", data);
        let vLstSection = []
        if (data.status === "Success") {
            vLstSection = data.lstSection;
            setLstSection(vLstSection)
            vLstSection.forEach((obj) => {
                if (obj.selected) {
                    lstSectionId.push(obj.sectionId)
                    lstSecPeriod.push({ sectionId: obj.sectionId, periods: obj.periods })
                }
            })
            // console.log("data", vLstSection);
        } else {
            if (data.message === "You are not logged in") {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else if (data.message === "Your Session is expired, login again") {
                toast.error(data.SvcMsg);
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        }
        setLoader('none')
    }
    const colgrp = <colgroup>
        <col width="5%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
        <col width="10%"></col>
    </colgroup>
    const openPopup = () => {
        setIsPopupOpen(true);
    }

    const closePopup = () => {
        setIsPopupOpen(false);
    }
    const selectAll = (e) => {
        var list_cbox = document.querySelectorAll('tbody td input[type=checkbox]');
        list_cbox.forEach((cbox) => { if (cbox.checked !== e.target.checked) cbox.click(); })
    }

    /*   function handleCboxChange(e, obj, status) {
          e.stopPropagation()
          if (status) {
              lstTmpAllocation.push({
                  allocationId: obj.allocationId,
                  clsId: obj.clsId,
                  sectionId: obj.sectionId,
                  subId: obj.subjectId
              })
          }
          else {
              var idx = existsIn(obj.clsId, obj.subjectId, obj.sectionId, lstTmpAllocation);
              lstTmpAllocation.splice(idx, 1)
          }
      }
  
      function existsIn(clsId, subId, sectionId, arr) {
          var idx = -1;
          for (var i = 0; i < arr.length; i++) {
              if (arr[i].subId === subId && arr[i].clsId === clsId && arr[i].sectionId === sectionId) {
                  idx = i;
                  break;
              }
          }
          return idx;
      } */



    function existsIn(pSectionId, arr) {
        // console.log('does ', pSectionId, 'exist in ', arr)
        var idx = -1;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].sectionId === pSectionId) {
                idx = i;
                break;
            }
        }
        return idx;
    }
    /* async function handleCBoxChange(obj, status) {
        // console.log(obj)
        // console.log(status)
        let lstTmpSec = lstSection;
        let lstTmpSecPeriod = lstSecPeriod;
        // console.log('lstSectionPeriod = ', lstSecPeriod)
        let lstTempArr = lstSectionId;
        let tmpPeriods = undefined
        if (lstSecPeriod.length > 0) {
            tmpPeriods = lstSecPeriod[lstSecPeriod.length - 1].periods
            // console.log(tmpPeriods)
        }
        if (status) {
            let idx = existsIn(obj.sectionId, lstSection);
            lstTmpSec[idx]['selected'] = true;
            await setLstSection(lstTmpSec)
            if (!lstTempArr.includes(obj.sectionId)) {
                lstTempArr.push(obj.sectionId)
                // console.log(lstTempArr)
                await setLstSectionId(lstTempArr)
            }
        }
        else {
            let idx1 = existsIn(obj.sectionId, lstSection);
            lstTmpSec[idx1]['selected'] = false;
            await setLstSection(lstTmpSec)
            let idx = existsIn(obj.sectionId, lstSecPeriod);
            lstTmpSecPeriod.splice(idx, 1);

            // console.log('lstTmpSecPeriod = ', lstTmpSecPeriod)
            await setLstSecPeriod(lstTmpSecPeriod)

            lstTempArr.splice(lstTempArr.indexOf(obj.sectionId), 1)
            await setLstSectionId(lstTempArr)
        }
    } */

    async function handleCBoxChange(obj, status) {
        // console.log(obj)
        // console.log(status)
        let lstTmpSec = lstSection;
        let lstTmpSelSec = lstSection
            .filter(item => item.selected);
        let tmpPeriods = undefined;
        if (lstTmpSelSec.length !== 0) {
            tmpPeriods = lstTmpSelSec[0].periods;
        }
        if (status == true) {
            if (tmpPeriods !== undefined && tmpPeriods != obj.periods) {
                toast.warn("Please select the sections with same count of periods");
                return;
            }
        }
        let idx = existsIn(obj.sectionId, lstSection);
        lstTmpSec[idx]['selected'] = status;
        await setLstSection(lstTmpSec)
        setLstSectionId(lstTmpSec
            .filter(item => item.selected)
            .map(item => item.sectionId));
    }

    function listEligibleTch() {
       /*  if (lstSectionId.length <= 1) {
            toast.warn("Please select atleast 2 classes");
            return;
        } */
        listEligibleTchSvc(subId, lstSectionId, cbEligibleTchResponse)
    }
    function cbEligibleTchResponse(data) {
        var obj = data;
        openPopup();
        // console.log("obj in cbEligibleTchResponse", obj);
        if (obj.status === "Success") {
            setLstTch(obj.lstTch)
        } else {
            toast.error(obj.message);
        }
    }

    const handleDaysChangeCbox = (event) => {
        const { id, checked } = event.target;

        // Log the current daysOff string before updating
        // console.log("daysOff before update:", daysOff);

        let updatedDaysOff = daysOff.split(""); // Convert string to array for easier manipulation

        // Update the specific day in the array based on checkbox
        updatedDaysOff[dayIndex[id]] = checked ? "1" : "0";

        // Join the array back to a string and update state
        setDaysOff(updatedDaysOff.join(""));
    };

    const handlePeriodChange = (event) => {
        const { id, checked } = event.target;
        const periodIndex = parseInt(id.replace("period", ""), 10) - 1;  // Convert "period1" to 0, "period2" to 1, etc.
        let updatedPeriodsOff = periodsOff.split("");
        updatedPeriodsOff[periodIndex] = checked ? "1" : "0";
        const newPeriodsOff = updatedPeriodsOff.join("");
        setPeriodsOff(newPeriodsOff);
        // console.log("Updated periodsOff:", newPeriodsOff);
    };




    return (
        <form
            className="form form-horizontal"
            style={{
                pointerEvents: loader === "none" ? "auto" : "none",
                width: '50%',
                height: '100%',
                overflowY: 'auto',
                zIndex: 999,
                position: 'fixed',
                right: 0,
                top: 0,
                backgroundColor: '#fff',
                transition: 'all .3s ease-in-out',
                border: '1px solid #ccc'
            }}>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="form-group col-sm-12">
                <label className="control-label col-md-2 text-left">Subject:<span className="red-color">*</span></label>
                <div className='col-sm-3 padding-remove'>
                    <select className="form-control" value={subId}
                        onChange={(e) => {
                            setSubId(e.target.value);
                            // console.log(props.commonClsId)
                            // console.log(e.target.value)
                            listSectionPeriodsSvc(props.commonClsId, e.target.value, cbSectionPeriodResponse);
                        }
                        }>
                        <option>Subject</option>
                        {lstSubject.map((obj, idx) => {
                            return <option key={idx} value={obj.subId}>{obj.sub}</option>
                        })}
                    </select>
                </div>
            </div>
            <div className="form-group col-sm-12">
                <label className="control-label col-md-2 text-left">Days Off:</label>

                <div className="col-sm-6 daysWrapper padding-remove">
                    <div className="text-center">
                        <span>M</span>
                        <input
                            autoComplete="off"
                            id="mon"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.mon] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                    <div className="text-center">
                        <span>T</span>
                        <input
                            autoComplete="off"
                            id="tue"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.tue] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                    <div className="text-center">
                        <span>W</span>
                        <input
                            autoComplete="off"
                            id="wed"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.wed] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                    <div className="text-center">
                        <span>Th</span>
                        <input
                            autoComplete="off"
                            id="thu"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.thu] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                    <div className="text-center">
                        <span>F</span>
                        <input
                            autoComplete="off"
                            id="fri"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.fri] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                    <div className="text-center">
                        <span>S</span>
                        <input
                            autoComplete="off"
                            id="sat"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.sat] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                    <div className="text-center">
                        <span>Su</span>
                        <input
                            autoComplete="off"
                            id="sun"
                            type="checkbox"
                            className="form-control dayCheckbox"
                            checked={daysOff[dayIndex.sun] === "1"}
                            onChange={handleDaysChangeCbox}
                        />
                    </div>
                </div>
            </div>
            <div className="form-group col-sm-12">
                <label className="control-label col-md-2 text-left">Periods Off:</label>

                <div className="col-sm-8 periodsWrapper padding-remove">
                    {[...Array(periodsOff.length)].map((_, i) => (
                        <div className="text-center" key={i}>
                            <span>{i + 1}</span>
                            <input
                                autoComplete="off"
                                id={`period${i + 1}`}
                                type="checkbox"
                                className="form-control periodCheckbox"
                                checked={periodsOff[i] === "1"}
                                onChange={handlePeriodChange}  // Use handlePeriodChange for periods
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="col-sm-11" style={{ height: '60%' }}>
                <div style={{ pointerEvents: loader === "none" ? "auto" : "none" }}>
                    <table className='tableLayout1'>
                        {colgrp}
                        <thead>
                            <tr>
                                <th>Class</th>
                                <th>Section</th>
                                <th>Periods</th>
                                <th>Select
                                    <div>
                                        <input onChange={(e) => selectAll(e)} type="checkbox" id="cbxSelectAll" />
                                    </div>
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <div className='tableDiv' style={{ height: '50vh' }}>
                        <table className='tableLayout'>
                            {colgrp}
                            <tbody>
                                {lstSection && lstSection.map((obj, idx) => {
                                    return <tr key={idx} id={'sect_' + obj.sectionId}
                                        onClick={(e) => { setSectionId(obj.sectionId); }}
                                        className={obj.sectionId === sectionId ? "selected" : ""}>
                                        <td>{obj.cls}</td>
                                        <td>{obj.section}</td>
                                        <td className="text-right">{obj.periods}</td>
                                        <td className="text-center">
                                            <input
                                                key={obj.sectionId + "_" + obj.selected}
                                                id={obj.sectionId + "_" + obj.selected}
                                                type="checkbox"
                                                checked={obj.selected}
                                                onClick={(e) => { e.preventDefault(); handleCBoxChange(obj, e.target.checked) }}
                                                readOnly />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="col-md-12 col-xs-12 col-centered padding-remove">
                <div className="form-group col-md-10">
                    <div className="pull-right col-md-1 padding-remove">
                        <button type="button" className="btn btn-info"
                            onClick={() => listEligibleTch()}>View Teachers</button>
                    </div>
                </div>
            </div>
            {isPopupOpen &&
                <EligibleTchPopup2
                    subId={subId}
                    eligibleTchId={props.tchId}
                    lstSectionId={lstSectionId}
                    closePopup={closePopup}
                    setLoader={setLoader}
                    lstTch={lstTch}
                    getCommonClsList={props.getCommonClsList}
                    closeSlider={props.closeSlider}
                    daysOff={daysOff}
                    periodsOff={periodsOff}
                />
            }

        </form>)
}
export default CommonClsSlider2;
